import React from 'react';
import PropTypes from 'prop-types';

import Label from 'zignal-landscape/lib/Label';
import Radio from 'zignal-landscape/lib/Radio';
import themeable from 'zignal-landscape/lib/themeable';

import SourceCheckerForm from '../SourceCheckerForm';
import StoryCheckerForm from '../StoryCheckerForm';


const CheckerModalForm = (props) => {
  // NOTE: "SourceType" is the 'type of Source being checked' vs. a Source Type like 'twitter', 'blogs', etc.
  const { styles, selectedSourceOrStoryType = undefined, selectedCheckByOption, sourcesOrStoriesToCheck = '',
    editSourcesOrStoriesList, setCheckBy, setSourceOrStoryType, hasSourcesExceededLimit,
    hasDomainsCommaSeparatedValues, profiles, handleProfilesChange, handleSourceSelection,
    selectedProfiles, selectedSource, handleTitleChanged, title = '', includeAll, handleIncludeAll,
  } = props;

  const checkBySection = selectedCheckByOption === 'sources' ? (
    <SourceCheckerForm
      hasExceededLimit={hasSourcesExceededLimit}
      hasDomainsCommaSeparatedValues={hasDomainsCommaSeparatedValues}
      selectedSourceType={selectedSourceOrStoryType}
      sourcesToCheck={sourcesOrStoriesToCheck}
      editSourcesList={editSourcesOrStoriesList}
      setSourceType={setSourceOrStoryType}
    />
  ) : (
    <StoryCheckerForm
      hasExceededLimit={hasSourcesExceededLimit}
      hasDomainsCommaSeparatedValues={hasDomainsCommaSeparatedValues}
      selectedStoryType={selectedSourceOrStoryType}
      storiesToCheck={sourcesOrStoriesToCheck}
      editStoriesList={editSourcesOrStoriesList}
      profiles={profiles}
      setStoryType={setSourceOrStoryType}
      handleProfilesChange={handleProfilesChange}
      handleSourceSelection={handleSourceSelection}
      selectedProfiles={selectedProfiles}
      selectedSource={selectedSource}
      title={title}
      handleTitleChanged={handleTitleChanged}
      includeAll={includeAll}
      handleIncludeAll={handleIncludeAll}
    /> );

  return (
    <div>
      <div>Check if certain sources or stories are covered by our platform</div>
      <div className={styles.optionMargin}>
        <Radio
          id="sources"
          name="checkBy"
          value="sources"
          checked={selectedCheckByOption === 'sources'}
          onChange={setCheckBy}
        />
        <Label htmlFor="sources" inline>Sources</Label>
        <Radio
          id="stories"
          name="checkBy"
          value="stories"
          checked={selectedCheckByOption === 'stories'}
          onChange={setCheckBy}
        />
        <Label htmlFor="stories" inline>Stories</Label>
      </div>
      {checkBySection}
    </div>
  );
};

CheckerModalForm.propTypes = {
  styles: PropTypes.object,
  selectedSourceOrStoryType: PropTypes.string,
  hasDomainsCommaSeparatedValues: PropTypes.bool,
  hasSourcesExceededLimit: PropTypes.bool,
  selectedCheckByOption: PropTypes.string,
  sourcesOrStoriesToCheck: PropTypes.string,
  title: PropTypes.string,
  editSourcesOrStoriesList: PropTypes.func,
  setCheckBy: PropTypes.func,
  setSourceOrStoryType: PropTypes.func,
  profiles: PropTypes.array,
  handleProfilesChange: PropTypes.func,
  handleSourceSelection: PropTypes.func.isRequired,
  selectedProfiles: PropTypes.array,
  selectedSource: PropTypes.string,
  handleTitleChanged: PropTypes.func,
  includeAll: PropTypes.bool,
  handleIncludeAll: PropTypes.func,
};

export default themeable(CheckerModalForm);
